import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import useSWR, { mutate } from 'swr'
import dayjs from 'dayjs'
import Btn from 'components/Btn'
import PageHeader from '../shared/PageHeader'
import ContactFilterBar from './components/ContactFilterBar'
import ContactTable from './components/ContactTable'
import ContactForm from './components/ContactForm'

export default withTranslation()(function ContactPerson({ t }) {
  const { isValidating } = useSWR('merchants/contacts')
  const [q, setQ] = useState('')
  const [type, setType] = useState('')
  const [status, setStatus] = useState('')
  const [showAdd, setShowAdd] = useState(false)
  const [lastUpdated, setLastUpdated] = useState(dayjs())

  useEffect(() => {
    if (!isValidating) setLastUpdated(dayjs())
  }, [isValidating])

  return (
    <section className="w-full">
      <PageHeader
        crumbs={[
          { name: t('settings.hub.title'), url: '/settings' },
          { name: t('settings.business_organization.title'), url: '/settings/business-organization' },
          { name: t('settings.business_organization.contact_person.page_title') }
        ]}
        title={t('settings.business_organization.contact_person.page_title')}
        right={
          <div className="flex items-center gap-2">
            <span className="text-sm text-secondary whitespace-nowrap">
              {t('settings.business_organization.contact_person.last_update', { date: lastUpdated.format('D MMM YY') })}
            </span>

            <button
              type="button"
              onClick={() => mutate('merchants/contacts')}
              className="w-9 h-9 rounded-full border border-border-lines flex items-center justify-center hover:bg-background shrink-0"
            >
              <UIcons.UilRedo className="text-secondary" size={16} />
            </button>

            <Btn
              content={() => <span className="flex items-center gap-1.5"><UIcons.UilPlus size={16} /> {t('settings.business_organization.contact_person.add')}</span>}
              className="text-white bg-primary rounded-full h-9 px-4 font-medium"
              click={() => setShowAdd(true)}
            />
          </div>
        }
      />

      <ContactFilterBar
        q={q}
        onChangeQ={setQ}
        type={type}
        onChangeType={setType}
        status={status}
        onChangeStatus={setStatus}
      />

      <ContactTable q={q} type={type} status={status} />

      {
        showAdd && (
          <ContactForm
            handleClick={() => setShowAdd(false)}
            onSaved={() => mutate('merchants/contacts')}
          />
        )
      }
    </section>
  )
})
